const Intro = () => {
	return (
		<section className="text-left" id="intro">
			<p className="hi-text">Hi there! My name is</p>
			<h1 className="intro-name">Jerry Safter-Brown.</h1>
			<h1 className="intro-title">I'm a Software Engineer.</h1>
			<p className="intro-description">
				I like solving problems and developing web interfaces that prioritize
				performance and user experience. I'm currently working as a Software
				Engineer at{" "}
				<a href="https://www.stickk.com/" target="_blank" rel="noreferrer">
					stickK
				</a>
				.
			</p>
		</section>
	);
};

export default Intro;
